module.exports = __webpack_public_path__ + "img/unibh-branco.84ac856f.svg";